module.exports = __webpack_public_path__ + "img/830.c9116a4c.png";